export { default } from './ChattelHomeDetails';
